import { render, staticRenderFns } from "./DescargarListaAbonados.vue?vue&type=template&id=65b4cedc"
import script from "./DescargarListaAbonados.vue?vue&type=script&setup=true&lang=js"
export * from "./DescargarListaAbonados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports